export default __webpack_public_path__ + "static/media/icon--copy.a7693789.svg";